(function () {
  var header = document.querySelector('.p-header');
  if (!header) return;

  var toggle = header.querySelector('.p-header__toggle');

  function close() {
    header.classList.remove('is-nav-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function () {
    var open = header.classList.toggle('is-nav-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  });

  header.querySelectorAll('.p-header__menu a').forEach(function (a) {
    a.addEventListener('click', close);
  });

  // カート数量バッジ
  var badge = header.querySelector('[data-cart-count]');
  if (!badge) return;

  function render(count) {
    badge.textContent = count > 99 ? '99+' : count;
    badge.hidden = count === 0;
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { render(cart.item_count); });
  }

  // テーマのカート追加・変更（pubsub）に追従
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  // ブラウザバック（bfcache）や別タブでの変更に追従
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
})();